import { gql } from "@apollo/client";

export const GET_FINANCIAL_HOURLY = gql`
  query vertical_sales_financial_hourly($where: reports_financial_hourly_bool_exp) {
    reports_financial_hourly(where: $where, order_by: { transaction_hour: asc }) {
      vendor_id
      vendor_name
      location_id
      location_name
      event_id
      event_name
      transaction_hour
      total_gross_sales
      gross_credit_sales
      gross_rfid_sales
      gross_cash_balance_sales
      gross_cash_sales
      gross_token_sales
      gross_promo_balance_sales
      total_tax
      total_tips
      total_discounts
      total_promo_discounts
      total_refunds
      total_transaction_count
    }
  }
`;

export const GET_PRODUCT_MIX = gql`
  query vertical_sales_product_mix($where: reports_product_mix_bool_exp) {
    reports_product_mix(where: $where, order_by: { pos_name: asc }) {
      pos_name
      description
      vendor_id
      vendor_name
      location_id
      location_name
      event_id
      event_name
      transaction_hour
      total_units_sold
      total_gross_sales
    }
  }
`;

export const GET_EVENT = gql`
  query vertical_sales_event($id: Int!) {
    events_by_pk(id: $id) {
      id
      name
      start_date
      end_date
    }
  }
`;
